import { useRef, useEffect } from 'react';

function useDelayedHover(_ref) {
  var open = _ref.open,
      close = _ref.close,
      openDelay = _ref.openDelay,
      closeDelay = _ref.closeDelay;
  var openTimeout = useRef(-1);
  var closeTimeout = useRef(-1);

  var clearTimeouts = function clearTimeouts() {
    window.clearTimeout(openTimeout.current);
    window.clearTimeout(closeTimeout.current);
  };

  var openDropdown = function openDropdown() {
    clearTimeouts();

    if (openDelay === 0) {
      open();
    } else {
      openTimeout.current = window.setTimeout(open, openDelay);
    }
  };

  var closeDropdown = function closeDropdown() {
    clearTimeouts();

    if (closeDelay === 0) {
      close();
    } else {
      closeTimeout.current = window.setTimeout(close, closeDelay);
    }
  };

  useEffect(function () {
    return clearTimeouts;
  }, []);
  return {
    openDropdown,
    closeDropdown
  };
}

export { useDelayedHover };